import { Flask } from 'client/components/Icons/Flask';
import { Globe } from 'client/components/Icons/Globe';
import { Scales } from 'client/components/Icons/Scales';

export const DeploymentStageIcons = {
  production: <Globe />,
  staging: <Scales />,
  development: <Flask />,
};

export const getDeploymentStageIcon = (stage: string) => {
  return Object.keys(DeploymentStageIcons).includes(stage)
    ? DeploymentStageIcons[stage as keyof typeof DeploymentStageIcons]
    : DeploymentStageIcons.production;
};
